/**
Copyright (C) 2019-2022, Infraclear Inc. All Rights Reserved.
*/

import axios from 'axios'
import { accessMangerBasePath, apiBasePath } from '../constants/env-url';

const instance = axios.create({
  withCredentials: true,
  baseURL: apiBasePath
})

instance.interceptors.request.use(
  async (config) => {
    config.headers.set("Content-Type", 'application/json');
    config.headers.set("Access-Control-Allow-Origin", '*');
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

instance.interceptors.response.use((response) => {
  return response;
}, error => {
  if (error?.response?.status === 401 || error?.response?.status === 500) {
    //place your reentry code
    localStorage.clear();
    window.location.href = `${accessMangerBasePath}/login`;
  }
  return Promise.reject(error);
});

export default instance;